import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

type FaqItem = {
  id: number;
  title: string;
  summary: string;
  icon: string;
  paragraphs?: string[];
  steps?: string[];
  bullets?: string[];
  nestedBullets?: { title: string; items: string[] };
};

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  activeId = 1;

  readonly faqItems: FaqItem[] = [
    {
      id: 1,
      title: 'Apa itu Mavensnomics?',
      summary: 'Gambaran singkat aplikasi',
      icon: 'fa-circle-info',
      paragraphs: [
        'Mavensnomics digunakan untuk mempermudah karyawan dalam mengajukan uang muka (cash advance) dan reimbursement secara digital, cepat, dan transparan.',
        'Seluruh proses pengajuan, persetujuan, pencairan, dan pertanggungjawaban dapat dilacak dalam satu sistem.',
      ],
    },
    {
      id: 2,
      title: 'Pengguna aplikasi',
      summary: 'Siapa yang bisa mengakses',
      icon: 'fa-users',
      paragraphs: [
        'Aplikasi hanya dapat digunakan oleh karyawan perusahaan yang sudah terdaftar dan diverifikasi oleh HR atau finance.',
        'Setiap pengguna memiliki role dan hak akses sesuai posisinya, misalnya claimer, approver, verificator, atau finance.',
      ],
    },
    {
      id: 3,
      title: 'Cash advance',
      summary: 'Alur pengajuan dan settlement',
      icon: 'fa-wallet',
      steps: [
        'Masuk ke menu cash advance, lalu pilih halaman pengajuan.',
        'Isi rencana pembiayaan: tujuan, estimasi biaya, tanggal, dan keterangan lainnya.',
        'Klik submit dan tunggu approval dari atasan atau finance.',
        'Setelah dana cair, buat settlement atau lembar pertanggungjawaban.',
        'Lengkapi data settlement beserta bukti transaksi dan sisa atau kekurangan dana.',
        'Klik submit untuk menyelesaikan proses settlement.',
      ],
      nestedBullets: {
        title: 'Data settlement biasanya mencakup:',
        items: [
          'Realisasi biaya yang digunakan.',
          'Bukti transaksi (struk atau invoice).',
          'Sisa dana yang dikembalikan atau tambahan biaya yang perlu diajukan.',
        ],
      },
    },
    {
      id: 4,
      title: 'Reimbursement',
      summary: 'Cara mengajukan penggantian biaya',
      icon: 'fa-receipt',
      steps: [
        'Masuk ke menu reimbursement.',
        'Isi detail pengajuan: tanggal, kategori biaya, dan nominal.',
        'Upload bukti transaksi seperti struk, invoice, atau tiket.',
        'Klik submit dan tunggu verifikasi dari finance atau atasan.',
        'Jika disetujui, dana reimbursement akan ditransfer ke rekening karyawan.',
      ],
    },
    {
      id: 5,
      title: 'Status pengajuan',
      summary: 'Arti setiap status',
      icon: 'fa-list-check',
      paragraphs: [
        'Status pengajuan dapat dicek di dashboard atau halaman riwayat masing-masing modul.',
      ],
      bullets: [
        'Waiting approval: menunggu persetujuan.',
        'Approved: disetujui dan sedang diproses.',
        'Rejected: ditolak, biasanya disertai catatan alasan.',
        'Disbursed atau reimbursed: proses pencairan atau penggantian biaya selesai.',
        'Closed: pengajuan telah ditutup setelah seluruh proses selesai.',
      ],
    },
    {
      id: 6,
      title: 'Keamanan data',
      summary: 'Perlindungan informasi pengguna',
      icon: 'fa-shield-halved',
      paragraphs: [
        'Semua data tersimpan dengan aman menggunakan enkripsi dan hanya dapat diakses oleh pihak berwenang.',
        'Akses data dibatasi berdasarkan role dan keterkaitan langsung dengan pengajuan yang bersangkutan.',
      ],
    },
    {
      id: 7,
      title: 'Bantuan & kendala',
      summary: 'Cara menghubungi tim support',
      icon: 'fa-headset',
      paragraphs: [
        'Jika mengalami kendala teknis atau proses, hubungi tim finance/HR melalui kanal resmi perusahaan.',
        'Anda juga dapat menghubungi support Mavensnomics melalui email: sari@mavens.co.id',
      ],
    },
  ];

  selectFaq(id: number): void {
    this.activeId = id;
  }

  get activeFaq(): FaqItem | undefined {
    return this.faqItems.find((item) => item.id === this.activeId);
  }
}
